// extracted by mini-css-extract-plugin
export default {"CareItem":"CareItem_CareItem__TTb6A","CareItemTitle":"CareItem_CareItemTitle__kEcoc","CareItemDescr":"CareItem_CareItemDescr__b8roe"};